/** 用户定价标签 */
export enum UserPricingTagEnum {
  /** 定价标签：2+1 */
  PRICING_TWO_PLUS_ONE = '2+1',
  /** 定价标签：2+0 */
  PRICING_TWO_PLUS_ZERO = '2+0',
}

/** 用户24圈客标签 */
export enum UserRisk24UserSourceEnum {
  /** 哈啰24：HL24 */
  HELLO_24_HL24 = 'HL24',
  /** 海消24：HX24 */
  SEA_24_HX24 = 'HX24',
  /** 未命中24 */
  NONE = '999',
}

export enum PageSourceEnum {
  /** 首页 */
  HOME = 'pageIndex',
  /** 我的页面 */
  MY_PROFILE = 'pageMyProfile',
}

/**
 * 信贷业务-公共信息
 */
export interface BusinessInfoExtra {
  /** 授信基础信息(服务端必定下发 && 异常时前端兜底默认值) */
  creditInfo: {
    /** 利率上限 */
    rateCeil: string;
    /** 利率下限 */
    rateFloor: string;
    /** 弹窗预估授信额度 */
    retentionPopupAmount?: string;
  };
  /** 授信用户信息 */
  userInfo?: {
    /** 定价标签 */
    pricingTag?: UserPricingTagEnum;
    /** 风险标签 */
    risk24UserSource?: UserRisk24UserSourceEnum;
    /** 是否命中ocr后置提现流程 */
    ocrAfterLoan?: boolean;
     /** 扩展对象 */
     extraData?: Record<string, unknown>;
  };
  /** 同步资产服务是否成功 */
  syncApiSuccess?: boolean;
}


export interface SyncUserInfoData {
  hasNameAndIdCard: boolean;
}

export enum PageSceneEnum {
  /** 首页 */
  HOME = 'HOMEPAGE',
  /** 提现结果页 */
  APPLY_RESULT = 'WITHDRAW_RESULT',
}
